// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>

const GETPAID_CHANGE_FORM_FIELD = 'GETPAID_CHANGE_FORM_FIELD';
const GETPAID_RESET_STATE = 'GETPAID_RESET_STATE';

const GETPAID_VALIDATE_MOBILE = 'GETPAID_VALIDATE_MOBILE';
const GETPAID_VALIDATE_EMAIL = 'GETPAID_VALIDATE_EMAIL';

const GETPAID_VALIDATE_FORM_FAILED = 'GETPAID_VALIDATE_FORM_FAILED';
const GETPAID_VALIDATE_FORM_SUCCESS = 'GETPAID_VALIDATE_FORM_SUCCESS';

const GETPAID_CONFIRM_ORDER_FOR_BOOKSHOP = 'GETPAID_CONFIRM_ORDER_FOR_BOOKSHOP';

const GETPAID_VALIDATE_FORM = 'GETPAID_VALIDATE_FORM';

const SET_DISCOUNT_CODE = 'SET_DISCOUNT_CODE';
const VALIDATE_DISCOUNT_CODE = 'VALIDATE_DISCOUNT_CODE';
const VALIDATE_DISCOUNT_CODE_STATUS = 'VALIDATE_DISCOUNT_CODE_STATUS';
const RESET_DISCOUNT_CODE = 'RESET_DISCOUNT_CODE';
const ACTIVE_DISCOUNT_CODE = 'ACTIVE_DISCOUNT_CODE';
const RESET_ACTIVE_DISCOUNT_CODE = 'RESET_ACTIVE_DISCOUNT_CODE';

export {
  GETPAID_CHANGE_FORM_FIELD,
  GETPAID_RESET_STATE,

  GETPAID_VALIDATE_MOBILE,
  GETPAID_VALIDATE_EMAIL,

  GETPAID_VALIDATE_FORM_FAILED,
  GETPAID_VALIDATE_FORM_SUCCESS,

  GETPAID_CONFIRM_ORDER_FOR_BOOKSHOP,

  GETPAID_VALIDATE_FORM,

  SET_DISCOUNT_CODE,
  VALIDATE_DISCOUNT_CODE,
  VALIDATE_DISCOUNT_CODE_STATUS,
  RESET_DISCOUNT_CODE,
  ACTIVE_DISCOUNT_CODE,
  RESET_ACTIVE_DISCOUNT_CODE,
};
